import SidebarContent from "./SidebarContent";

type SidebarProps = {
  accounts: Record<string, any>;
  showSidebar: boolean;
};

const Sidebar = ({ accounts, showSidebar }: SidebarProps) => {
  return (
    <div className={`flex flex-col ${showSidebar ? "w-1/5" : "w-0"} transition-width duration-300 bg-muted dark:bg-background justify-between overflow-y-auto shadow-inner dark:border-r max-md:hidden`}>
      <SidebarContent accounts={accounts} />
    </div>
  );
};

export default Sidebar;
